/**
 * Skill drills: the URL picks the screen, the menu links to each.
 *   /workshop-builder          → New skill drill (default)
 *   /workshop-builder/library  → Skill drills (the library)
 *   /workshop-builder/plots    → New skill drill with the plots panel open:
 *                                the panel replaced the Plots & Frameworks
 *                                page (CC brief 2, Nino approved 6 Oct), so
 *                                old links still land somewhere useful.
 */
import { lazy, Suspense, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { WBTab } from '@/types/skill-drill-builder';

// Lazy-load each screen to keep the first download small.
const SkillDrillCreator = lazy(() => import('./tabs/SkillDrillCreator'));
const SkillDrillLibrary = lazy(() => import('./tabs/SkillDrillLibrary'));

const BASE = '/workshop-builder';

function TabLoader() {
  return (
    <div className="flex items-center justify-center h-48">
      <div className="flex flex-col items-center gap-2">
        <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        <span className="text-sm text-muted-foreground">Loading...</span>
      </div>
    </div>
  );
}

export default function SkillDrillBuilder() {
  const { pathname } = useLocation();
  const segment = useMemo(() => pathname.replace(BASE, '').replace(/^\//, '').split('/')[0], [pathname]);
  const activeTab: WBTab = segment === 'library' ? 'library' : 'create';


  return (
    <Suspense fallback={<TabLoader />}>
      {activeTab === 'create' && <SkillDrillCreator key={segment} openPlots={segment === 'plots'} />}
      {activeTab === 'library' && <SkillDrillLibrary />}
    </Suspense>
  );
}
